import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { ChevronRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LegalPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setPage(null); setError(false);
    axios.get(`${API}/pages/${slug}`).then(({ data }) => setPage(data)).catch(() => setError(true));
    window.scrollTo(0, 0);
  }, [slug]);

  if (error) {
    return <div className="min-h-screen flex items-center justify-center"><p className="text-muted-foreground">Page introuvable</p></div>;
  }
  if (!page) {
    return <div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-orange"></div></div>;
  }

  const blocks = page.content.split(/\n\s*\n/);

  return (
    <div className="min-h-screen bg-surface py-8">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <nav className="flex items-center gap-2 text-sm text-muted-foreground mb-6">
          <Link to="/" className="hover:text-brand-orange">Accueil</Link>
          <ChevronRight className="w-3 h-3" />
          <span className="text-foreground">{page.title}</span>
        </nav>
        <article className="bg-white rounded-sm border border-border p-6 md:p-10" data-testid={`legal-page-${slug}`}>
          <h1 className="text-3xl md:text-4xl font-bold mb-8" style={{ fontFamily: 'IBM Plex Sans' }} data-testid="legal-page-title">{page.title}</h1>
          <div className="space-y-5 text-foreground leading-relaxed">
            {blocks.map((block, i) => {
              const [first, ...rest] = block.split('\n');
              const isHeading = rest.length > 0 && first.length < 80 && !/[.:]$/.test(first.trim());
              return (
                <section key={i}>
                  {isHeading ? (
                    <>
                      <h2 className="text-base md:text-lg font-semibold mb-2 text-brand-dark">{first}</h2>
                      <p className="text-sm md:text-base whitespace-pre-line text-muted-foreground">{rest.join('\n')}</p>
                    </>
                  ) : (
                    <p className="text-sm md:text-base whitespace-pre-line">{block}</p>
                  )}
                </section>
              );
            })}
          </div>
          {page.updated_at && (
            <p className="text-xs text-muted-foreground mt-10">Dernière mise à jour : {new Date(page.updated_at).toLocaleDateString('fr-FR')}</p>
          )}
        </article>
      </div>
    </div>
  );
}
